import React from "react";
import { ResponsivePie } from "@nivo/pie";

type ChartDatum = {
    id: string;
    label: string;
    value: number;
    color?: string;
};

interface PieChartProps {
    data: ChartDatum[];
}

const PieChart: React.FC<PieChartProps> = ({ data }) => {
    return (
        <div className="h-p-100 w-p-100">
            <ResponsivePie
                data={data.map(d => ({
                    ...d,
                    color: d.color || "#ccc",
                }))}
                margin={{ top: 40, right: 80, bottom: 40, left: 80 }}
                innerRadius={0}
                padAngle={1}
                cornerRadius={3}
                borderWidth={1}
                borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
                colors={{ datum: "data.color" }}
                enableArcLabels={true}
                arcLabelsSkipAngle={10}
                arcLinkLabelsSkipAngle={10}
                arcLabel={""}
                tooltip={({ datum }) => (
                    <div className="p-1 d-flex bg-color-secondary br-1 h6-medium max-w-20 w-space"
                        style={{
                            color: datum.color,
                            border: `1px solid ${datum.color}`
                        }}
                    >
                        {datum.label} : {datum.value}
                    </div>
                )}
                theme={{
                    labels: {
                        text: {
                            fontSize: 12,
                            fontWeight: 500,
                            fill: "#333",
                        },
                    },
                }}
            />
        </div>
    );
};

export default PieChart;
